export const isTestEnvironment = window.location.hostname !== 'tipi.ink' && window.location.hostname !== 'www.tipi.ink'
